const getters = {
  token: state => state.user.token,
  userId: state => state.user.userId,
  userName: state => state.user.userName,
  roleCode: state => state.user.roleCode
};
export default getters;
